import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import './AuthPage.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.forgotPassword(email);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="auth-page container">
      <div className="auth-card card">
        <h1 className="auth-flow-title">Forgot password</h1>
        <p className="auth-flow-lead">
          Enter the email you used to create your account. We will send you a link to choose a new password.
        </p>

        {done ? (
          <>
            <p className="auth-success-text">
              If an account exists for that email, you will receive a link to reset your password shortly.
              Check your spam folder if nothing arrives in a few minutes.
            </p>
            <Link to="/" className="btn btn-primary btn-block auth-submit" style={{ textAlign: 'center', textDecoration: 'none' }}>
              Back to menu
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            {error && <p className="error-text">{error}</p>}
            <button type="submit" className="btn btn-primary btn-block auth-submit" disabled={submitting}>
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <p className="auth-privacy" style={{ marginTop: 16 }}>
          <Link to="/">← Back to sign in</Link>
        </p>
      </div>
    </main>
  );
}
